const KPOP_TAGS_API_BASE =
  "https://bunjang-webhook-api.hallyu-manager.com/_api/v1/kpop-tags";

export type KpopTag = {
  id: number;
  name: string;
};

export type KpopTagsPage = {
  content: KpopTag[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  last: boolean;
};

/**
 * GET /_api/v1/kpop-tags?keyword=&page=&size=
 * keyword: name/slug 부분 일치. 생략 시 전체 조회.
 */
export async function fetchKpopTags(
  keyword: string | undefined,
  page: number,
  size: number,
  signal?: AbortSignal
): Promise<KpopTagsPage> {
  const url = new URL(KPOP_TAGS_API_BASE);
  const trimmed = keyword?.trim();
  if (trimmed) {
    url.searchParams.set("keyword", trimmed);
  }
  url.searchParams.set("page", String(page));
  url.searchParams.set("size", String(size));

  const res = await fetch(url.toString(), { method: "GET", signal });

  if (!res.ok) {
    throw new Error(`kpop-tags API ${res.status} ${res.statusText}`);
  }

  return (await res.json()) as KpopTagsPage;
}
